import * as Yup from 'yup'

const CredentialsSchema = Yup.object().shape({
  credKey: Yup.string().required('Key Required'),
  // value: Yup.string().max(100).required('Value Required'),
  // description: Yup.string().max(200).required('Description Required')
})

export const affiliateSystemSchema = (myKeys) => {
  const validationObject = {}
  if (myKeys && Object.keys(myKeys)?.length) {
    for (const file of myKeys) {
      validationObject[file] = Yup.string().required('Value Required.')
    }
  }
  return Yup.object(validationObject)
}

export const whiteListedDomainsSchema = () => {
  return Yup.object().shape({
    domains: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required('Domain name required')
        })
      )
      .required('Add domains in the list')
  })
}

export const sessionSettingsSchema = (isTenant, isSuperAdminWithRoleOne, isSessionSettingsActive) => {
  const baseSchema = {
    loginCount: Yup.number()
      .nullable()
      .typeError('Login Count must be a number')
      .integer('Login Count must be an integer')
      .min(0, 'Login Count must be 0 or greater')
      .when([], (schema) => {
        return isSessionSettingsActive
          ? schema
            .required('User Login Count is required when session settings are active')
            .moreThan(0, 'User Login Count must be greater than 0 when session settings are active')
          : schema
      }),

    userSessionExpiry: Yup.number()
      .nullable()
      .typeError('User Session Expiry must be a number')
      .integer('User Session Expiry must be an integer')
      .min(0, 'User Session Expiry must be 0 or greater')
      .when([], (schema) => {
        return isSessionSettingsActive
          ? schema
            .required('User Session Expiry is required when session settings are active')
            .moreThan(0, 'User Session Expiry must be greater than 0 when session settings are active')
          : schema
      }),

    adminSessionExpiry: Yup.number()
      .nullable()
      .typeError('Admin Session Expiry must be a number')
      .integer('Admin Session Expiry must be an integer')
      .min(0, 'Admin Session Expiry must be 0 or greater'),

    superadminSessionExpiry: Yup.number()
      .nullable()
      .typeError('Superadmin Session Expiry must be a number')
      .integer('Superadmin Session Expiry must be an integer')
      .min(0, 'Superadmin Session Expiry must be 0 or greater')
  }

  // Conditional object shape
  if (isTenant) {
    return Yup.object().shape({
      loginCount: baseSchema.loginCount,
      userSessionExpiry: baseSchema.userSessionExpiry
    })
  }

  if (!isTenant && isSuperAdminWithRoleOne) {
    return Yup.object().shape(baseSchema)
  }

  // !isTenant && !isSuperAdminWithRoleOne
  return Yup.object().shape({
    loginCount: baseSchema.loginCount,
    userSessionExpiry: baseSchema.userSessionExpiry,
    adminSessionExpiry: baseSchema.adminSessionExpiry
  })
}

export default CredentialsSchema
